import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

const Table = ({ className, headers, rows, loading }) => (
  <div className={cn("flex flex-col", className)}>
    <div className="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
      <div className="align-middle inline-block min-w-full shadow overflow-hidden rounded-lg border-b border-gray-200 mb-3">
        <table className="min-w-full">
          <thead>
            <tr>
              {headers.map(header => (
                <th
                  key={header}
                  className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr>
                <th className="px-6 py-3 whitespace-no-wrap leading-5 test-sm text-gray-500 font-medium">
                  Loading...
                </th>
              </tr>
            )}
            {!loading && rows.length === 0 && (
              <tr>
                <th className="px-6 py-3 whitespace-no-wrap leading-5 test-sm text-gray-500 font-medium">
                  No data
                </th>
              </tr>
            )}
            {!loading &&
              rows.length > 0 &&
              rows.map(({ key, row }, index) => (
                <tr
                  key={key}
                  className={index % 2 === 1 ? "bg-gray-50" : "bg-white"}
                >
                  {row.map((td, column) => (
                    <td className="px-6 py-3 whitespace-no-wrap text-sm leading-5">
                      {td}
                    </td>
                  ))}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

Table.defaultProps = {
  className: "",
  headers: [],
  rows: [],
  loading: false
};

Table.propTypes = {
  className: PropTypes.string,
  headers: PropTypes.arrayOf(PropTypes.node),
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      row: PropTypes.node.isRequired
    })
  ),
  loading: PropTypes.bool
};

export default Table;
